import { Box } from '@material-ui/core';

import { SButton, SText } from '@setvi/shared/components';
import { usePreviewStyles } from 'componentsV2/pdf-preview-dialog';

interface UnavailableContentProps {
  /** Omitted when there is no file to open (asset without a url). */
  onOpenFile?: () => void;
}

/** Shown for a file type the preview cannot render inline. */
export const UnavailableContent = ({ onOpenFile }: UnavailableContentProps) => {
  const classes = usePreviewStyles();

  return (
    <Box className={classes.scrollArea}>
      <Box
        margin="auto"
        display="flex"
        gridGap={16}
        alignItems="center"
        flexDirection="column">
        <SText title="Preview is not available for this resource." />
        {onOpenFile && (
          <SButton variant="outlined" onClick={onOpenFile}>
            Open file
          </SButton>
        )}
      </Box>
    </Box>
  );
};
